import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryListTrendingIntegrityProps {
    items?: CuratedItem[];
}

export default function integrityCheck({
    items,
}: StoryListTrendingIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items);
}
